
import { addEventListeners, getNextSibling } from "../utils/dom";
export default class GlobalNav extends HTMLElement {

    connectedCallback() {

        addEventListeners("#global-navigation [data-globalmenu='dropdown-parent']", "click",
            (e) => {
                e.preventDefault();

                // Hide all dropdowns except the current one
                Array.from(document.querySelectorAll(".dropdown-menu"))
                    .filter(menu => !menu.parentNode.contains(e.target))
                    .forEach(menu => menu.classList.remove("show"));

                // Toggle this items menu if it exists
                const dropdownMenu = getNextSibling(e.target, ".dropdown-menu");

                if (dropdownMenu) {
                    dropdownMenu.classList.toggle("show");
                }
                
            });

        // Hide dropdowns on click outside
        document.addEventListener("click", (event) => {
            if (!event.target.closest(".global-navigation-listitem")?.length) {
                document.querySelector(".dropdown-menu").classList.remove("show");
            }
        });

        addEventListeners(".global-navigation-listitem", "click", (e) => {
            e.stopPropagation();
        });

        addEventListeners(".dropdown-menu-close-btn", "click", (e) => {
            e.target.closest(".dropdown-menu").classList.remove("show");
        });

    }

}

customElements.define('global-nav', GlobalNav, { extends: 'nav' });